module.exports = __webpack_public_path__ + "img/pc-manage.a1ebbb19.png";